export default __webpack_public_path__ + "static/media/NH08.ec286674.jpg";